module.exports = __webpack_public_path__ + "img/sec_in_device3.051d2b76.png";